import { useState } from "react";
import { Upload, Check } from "lucide-react";
import { Dialog, DialogContent, DialogTitle } from "../ui/dialog";
import { api, img } from "../../lib/api";
import { useLoad, act, btn, inp } from "./kit";

export async function uploadFiles(files) {
  const fd = new FormData();
  Array.from(files).forEach((f) => fd.append("files", f));
  return act(() => api.post("/admin/media", fd, { headers: { "Content-Type": "multipart/form-data" } }), "Uploaded");
}

export default function MediaPicker({ open, onClose, onPick, multiple = true }) {
  const [q, setQ] = useState("");
  const { data, reload } = useLoad("/admin/media", { q });
  const [sel, setSel] = useState([]);
  const [busy, setBusy] = useState(false);
  const toggle = (m) => setSel((s) => (s.find((x) => x.id === m.id) ? s.filter((x) => x.id !== m.id) : multiple ? [...s, m] : [m]));
  const upload = async (e) => {
    setBusy(true);
    const res = await uploadFiles(e.target.files);
    setBusy(false);
    if (res) { reload(); setSel((s) => (multiple ? [...s, ...res] : [res[0]])); }
  };
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-3xl max-h-[90vh] overflow-y-auto" data-testid="media-picker">
        <DialogTitle className="font-serif text-2xl">Choose images</DialogTitle>
        <div className="flex flex-col sm:flex-row gap-2">
          <input className={inp} placeholder="Search media" value={q} onChange={(e) => setQ(e.target.value)} data-testid="media-picker-search" />
          <label className={`${btn} cursor-pointer whitespace-nowrap`}><Upload className="w-4 h-4" /> {busy ? "Uploading…" : "Upload from device"}<input type="file" multiple accept="image/jpeg,image/png,image/webp" className="hidden" onChange={upload} data-testid="media-picker-upload-input" /></label>
        </div>
        <p className="text-[11px] text-stone-400">JPG, JPEG, PNG or WEBP up to 8 MB. Large images are resized automatically.</p>
        <div className="grid grid-cols-3 sm:grid-cols-5 gap-2">
          {(data || []).map((m) => {
            const on = sel.find((x) => x.id === m.id);
            return (
              <button key={m.id} onClick={() => toggle(m)} className={`relative aspect-square rounded-lg overflow-hidden border-2 ${on ? "border-[#1B3B2B]" : "border-transparent"}`} data-testid="media-picker-item">
                <img src={img(m.url)} alt={m.alt} className="w-full h-full object-cover" />
                {on && <span className="absolute top-1 right-1 bg-[#1B3B2B] text-white rounded-full p-0.5"><Check className="w-3 h-3" /></span>}
              </button>
            );
          })}
          {data && !data.length && <p className="col-span-full text-sm text-stone-500">No images yet — upload one above.</p>}
        </div>
        <div className="flex justify-end gap-2">
          <button className={btn} disabled={!sel.length} onClick={() => { onPick(sel); setSel([]); onClose(); }} data-testid="media-picker-confirm">Use {sel.length || ""} selected</button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
